import * as React from 'react';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import Layout from '../../components/Layout';
import KaiZenHero from '../../components/KaiZen/KaiZenHero/KaiZenHero';
import DidYouKnow from '../../components/Invite/Kaizen/DidYouKnow';
import WhyKaiZen from '../../components/KaiZen/WhyKaiZen/WhyKaiZen';
import KaiZenIsDifferent from '../../components/KaiZen/KaiZenIsDifferent/KaiZenIsDifferent';
import CarouselEditor from '../../components/Editor/CarouselEditor';
import FindAgent from '../../components/FindAgent';
import AppContext from '../../components/AppContext';
import EstimationFinal from '../../components/KaiZen/Estimation/EstimationFinal';
import Disclaimer from '../../components/Disclaimer/Disclaimer';
import fetchData from '../../lib/fetchData';

export const getServerSideProps: GetServerSideProps = fetchData('/api/pages/kai-zen-main');

function Kaizen(props: any) {
  const {
    kaizenTitle,
    kaizenSlogan,
    kaizenSloganDescendantText,
    strategyText,
    strategyDescendantText,
    didYouKnow,
    didYouKnowDescendantText,
    whyKaizen,
    whyKaizenDescendantText,
    valueProvided,
    valueProvidedList,
    requiredQualifications,
    requiredQualificationsList,
    kaizenDifferent,
    kaizenDifferentDescendantText,
    smartLeverage,
    smartLeverageList,
    moreProtection,
    moreProtectionList,
    moreGrowth,
    moreGrowthList,
    niwStrategy,
    findAgentTitle,
    findAgentSubTitle,
    findAgentByZipTitle,
    kaiZenEstimator,
    imgEmployeehandshake,
    bgImage,
    carouselId,
    videoUrl,
    iliaTitle,
    iliaDesc,
    iliaStrategyList,
    handWithIpad
  } = props.data;
  const [pageDescriptionMeta, pageTitle] = [
    'Kaizen® Retirement Insurance Plan is a cash value life insurance policy that can help you secure your financial future. With Kaizen® whole life insurance policy, you can accumulate cash value tax-deferred, and you can use the policy to generate income in retirement. Learn more about how Kaizen® can help you achieve your retirement goals.',
    'Kaizen Retirement Plan - Cash Value Life Insurance | Whole Life Insurance Policy'
  ];
  const [step, setStep] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isUnderstandDisclaimer, setUnderstandDisclaimer] = React.useState(false);
  const router = useRouter();
  const containerRef = React.createRef<any>();
  const scrollTop = () => {
    containerRef?.current?.scrollIntoView({behavior: 'smooth', block: 'start'});
  };

  React.useEffect(() => {
    const {landing} = router.query;
    if (landing) {
      setStep(Number(landing));
    }
    if (landing && step === 1) {
      scrollTop();
    }
  });

  React.useEffect(() => {
    if (isUnderstandDisclaimer) {
      setStep(1);
    }
  }, [isUnderstandDisclaimer]);

  if (step === 1) {
    return (
      <AppContext.Provider value={props.page}>
        <div className="floatLeft w100" ref={containerRef}>
          <Layout title={pageTitle} keyword={props.keyword} pageDescription={pageDescriptionMeta}>
            <EstimationFinal
              iliaTitle={iliaTitle}
              iliaDesc={iliaDesc}
              iliaStrategyList={iliaStrategyList}
              handWithIpad={handWithIpad}
            />
          </Layout>
        </div>
      </AppContext.Provider>
    );
  }

  return (
    <AppContext.Provider value={props.page}>
      <div ref={containerRef}></div>
      <Layout title={pageTitle} keyword={props.keyword} pageDescription={pageDescriptionMeta}>
        <KaiZenHero
          kaizenTitle={kaizenTitle}
          kaizenSlogan={kaizenSlogan}
          kaizenSloganDescendantText={kaizenSloganDescendantText}
          strategyText={strategyText}
          strategyDescendantText={strategyDescendantText}
          bgImage={bgImage}
          videoUrl={videoUrl}
          setOpenDialog={setOpenDialog}
          isUnderstandDisclaimer={isUnderstandDisclaimer}
        />
        <DidYouKnow
          didYouKnow={didYouKnow} didYouKnowDescendantText={didYouKnowDescendantText}
        />
        <WhyKaiZen
          whyKaizen={whyKaizen}
          whyKaizenDescendantText={whyKaizenDescendantText}
          valueProvided={valueProvided}
          valueProvidedList={valueProvidedList}
          requiredQualifications={requiredQualifications}
          requiredQualificationsList={requiredQualificationsList}
          kaiZenEstimator={kaiZenEstimator}
        />
        <KaiZenIsDifferent
          kaizenDifferent={kaizenDifferent}
          kaizenDifferentDescendantText={kaizenDifferentDescendantText}
          smartLeverage={smartLeverage}
          smartLeverageList={smartLeverageList}
          moreProtection={moreProtection}
          moreProtectionList={moreProtectionList}
          moreGrowth={moreGrowth}
          moreGrowthList={moreGrowthList}
          niwStrategy={niwStrategy}
          imgEmployeehandshake={imgEmployeehandshake}
        />
        <CarouselEditor carouselId={carouselId}/>
        <FindAgent
          findAgentTitle={findAgentTitle}
          findAgentSubTitle={findAgentSubTitle}
          findAgentByZipTitle={findAgentByZipTitle}
        />
        <Disclaimer
          setOpenDialog={setOpenDialog} openDialog={openDialog} setUnderstandDisclaimer={setUnderstandDisclaimer}
        />
      </Layout>
    </AppContext.Provider>
  )
}

export default Kaizen;
